import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

const PostImages = ({ postImages, onPostImageSelected }) => {
  const classes = useStyles();

  function FormRow() {
    const images = postImages.map(image => {
      return (
        <Grid
          style={{ cursor: 'pointer' }}
          key={image}
          item xs={4}
          onClick={() => onPostImageSelected(image.display)}
        >
          <Paper className={classes.paper}>
            <img src={image.display} />
          </Paper>
        </Grid>
      );
    });
    return images;
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid container item xs={12} spacing={3}>
          <React.Fragment>
            <FormRow />
          </React.Fragment>
        </Grid>
      </Grid>
    </div>
  );
}

export default PostImages;